/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

const DUPLICATE_SKU_CODE = 'DUPLICATE_SKU';
const DUPLICATE_SKU_SERVER_SUBCODE = 'DuplicateSkuApiError';

const isDuplicateSkuError = (subcode, errorMessage) => (
  subcode === DUPLICATE_SKU_CODE
  || subcode === DUPLICATE_SKU_SERVER_SUBCODE
  || errorMessage === 'SKU already exists'
);

export const create = createAsyncThunk(
  'products/create',
  async ({ title, sku, status }, {
    extra: {
      sdk, utils, Logger, showErrorDialog,
    },
    getState,
    rejectWithValue,
  }) => {
    try {
      const { data } = await sdk.products.createMasterProduct({ title, sku, status });
      Logger.log('UI', 'product_created', {
        product_title: title,
        product_sku: sku,
        product_status: status,
        created_by: getState().user._id,
      });
      return data;
    } catch (error) {
      const subcode = utils.getDataFromResponceError(error, 'subcode');
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not create product';

      Logger.error(new Error('Error product creating'), { error }, [
        'CreateProductFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);

      if (isDuplicateSkuError(subcode, errorMessage)) {
        return rejectWithValue({ code: DUPLICATE_SKU_CODE, message: errorMessage });
      }

      showErrorDialog(errorMessage);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      create.pending,
      (state, { meta }) => {
        state.nameCreatingProduct = meta.arg.title;
      },
    )
    .addCase(
      create.fulfilled,
      (state, { payload }) => {
        state.items.unshift({
          ...payload,
          variants: payload.variants || [],
        });
        state.nameCreatingProduct = null;
        state.error = null;
      },
    )
    .addCase(
      create.rejected,
      (state, { error }) => {
        state.nameCreatingProduct = null;
        state.error = error;
      },
    );
};
